module.exports = __webpack_public_path__ + "img/phone-placeholder-image.323d86e1.svg";